export type CertificationBadge = {
  id: string;
  label: string;
  image: string;
  alt: string;
  tooltip: string;
  accent: string;
  size?: 'large';
};

export const certificationBadges: CertificationBadge[] = [
  {
    id: 'soc2-cert',
    label: 'SOC 2 TYPE II',
    image: '/badge-soc2-type2.webp',
    alt: 'SOC 2 TYPE II badge',
    tooltip:
      'Independent auditors review our security controls all year, so you can hand stakeholders current evidence instead of last year\u2019s report.',
    accent: 'rgba(198, 167, 94, 0.35)'
  },
  {
    id: 'iso-cert',
    label: 'ISO/IEC 27001',
    image: '/badge-iso-27001.webp',
    alt: 'ISO/IEC 27001 badge',
    tooltip:
      'Our security program follows the global ISO 27001 playbook\u2014risk registers, treatments, and board reviews included.',
    accent: 'rgba(182, 146, 76, 0.32)'
  },
  {
    id: 'gdpr-cert',
    label: 'GDPR COMPLIANT',
    image: '/badge-gdpr.webp',
    alt: 'GDPR badge',
    tooltip:
      'We honor every EU privacy request with proof: data residency, DPAs, sub-processor flowdowns, and timed deletion receipts.',
    accent: 'rgba(198, 167, 94, 0.28)',
    size: 'large'
  },
  {
    id: 'tls-cert',
    label: 'TLS 1.3 ENCRYPTED',
    image: '/badge-tls-13.webp',
    alt: 'TLS 1.3 badge',
    tooltip: 'Edge-to-core TLS 1.3 keeps traffic encrypted, so anyone listening on the wire only sees gibberish.',
    accent: 'rgba(26, 26, 26, 0.2)'
  },
  {
    id: 'zero-training-cert',
    label: 'ZERO AI TRAINING',
    image: '/badge-zero-training.webp',
    alt: 'ZERO AI training badge',
    tooltip: 'Enterprise-only AI endpoints block fine-tuning, so vendors cannot learn from or store your prompts.',
    accent: 'rgba(198, 167, 94, 0.32)'
  }
];
